import axiosInstance from './api.service';
import constants from '../constants/constants';

const chat = (question, history = [], clarificationOption) => {
  return axiosInstance.post('ai/chat', { question, history, ...(clarificationOption ? { clarificationOption } : {}) }, constants.REQUIRE_INTERCEPTORS);
};

const searchProjects = (query = '', limit = 8) => {
  return axiosInstance.get(`ai/projects/search?query=${encodeURIComponent(query)}&limit=${limit}`, constants.REQUIRE_INTERCEPTORS);
};

const getAccess = () => {
  return axiosInstance.get('ai/access', constants.REQUIRE_INTERCEPTORS);
};

export { chat, searchProjects, getAccess };
